export default __webpack_public_path__ + "media/images/printButton-dc10469a7ddc95d3a4911f881bc38162.png";